import MxSelectAgentsField, {
  MxSelectAgentsFieldProp
} from "@rf-l1/form/selects/MxSelectAgentsField";
import { useMxFieldControllerContext } from "@rf/context/MxFieldController";

type omit = "value" | "id" | "name" | "testId" | "items" | "onChange";

export type MxFormSelectAgentsFieldProp = Omit<MxSelectAgentsFieldProp, omit>;

const MxFormSelectAgentsField = (props: MxFormSelectAgentsFieldProp) => {
  const { onChange, onBlur, name, value, invalid, id, testId, inputRef } =
    useMxFieldControllerContext();

  return (
    <MxSelectAgentsField
      {...props}
      id={id}
      testId={testId}
      onChange={onChange}
      onBlur={onBlur}
      name={name}
      value={value}
      error={invalid}
      inputRef={props.usePortal ? undefined : inputRef}
    />
  );
};

export default MxFormSelectAgentsField;
